import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getConfigurationReport, loadConfigReport } from "../app/store/dashboard";

const ApplicationStatics = () => {
  const [configReport, setConfigReport] = useState(null);

  const configurationReportSelector = useSelector(getConfigurationReport);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadConfigReport());
  }, []);

  useEffect(() => {
    setConfigReport(configurationReportSelector);
  }, [configurationReportSelector]);

  const statCards = [
    { name: "Workflows", sub: "All Versions", icon: "fa-sitemap", gradient: "linear-gradient(135deg, #6366f1, #818cf8)", count: configReport?.workflow },
    { name: "Subprocesses", sub: "All Versions", icon: "fa-code-fork", gradient: "linear-gradient(135deg, #10b981, #34d399)", count: configReport?.subProcess },
    { name: "Rules", sub: "", icon: "fa-gavel", gradient: "linear-gradient(135deg, #f59e0b, #fbbf24)", count: configReport?.rules },
    { name: "Forms", sub: "", icon: "fa-wpforms", gradient: "linear-gradient(135deg, #8b5cf6, #a78bfa)", count: configReport?.forms },
    { name: "Form Libraries", sub: "", icon: "fa-book", gradient: "linear-gradient(135deg, #ec4899, #f472b6)", count: configReport?.formLibrary },
    { name: "Documents", sub: "", icon: "fa-file-text-o", gradient: "linear-gradient(135deg, #06b6d4, #22d3ee)", count: configReport?.documents },
    { name: "Document Storage", sub: "", icon: "fa-database", gradient: "linear-gradient(135deg, #64748b, #94a3b8)", count: 0 },
  ];

  const appStatStyles = `
    .app-stat-grid {
      display: grid;
      gap: 14px;
      grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
      padding: 4px 0;
    }

    .app-stat-card {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);
      overflow: hidden;
      padding: 18px 16px;
      position: relative;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .app-stat-card:hover {
      box-shadow: 0 8px 28px rgba(15, 23, 42, 0.1);
      transform: translateY(-3px);
    }

    .app-stat-card::before {
      content: "";
      height: 3px;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
    }

    .app-stat-icon-wrap {
      align-items: center;
      border-radius: 10px;
      color: #ffffff;
      display: inline-flex;
      font-size: 16px;
      height: 38px;
      justify-content: center;
      margin-bottom: 14px;
      width: 38px;
    }

    .app-stat-icon-wrap i {
      font-family: FontAwesome !important;
    }

    .app-stat-label {
      color: #64748b;
      font-size: 11.5px;
      font-weight: 600;
      letter-spacing: 0.04em;
      margin: 0;
      text-transform: uppercase;
    }

    .app-stat-sub {
      color: #94a3b8;
      font-size: 10.5px;
      font-weight: 600;
      margin: 2px 0 0;
    }

    .app-stat-count {
      color: #0f172a;
      font-size: 26px;
      font-weight: 600;
      line-height: 1;
      margin-top: 10px;
    }
  `;

  const renderStatCard = ({ name, sub, icon, gradient, count }) => (
    <div className="app-stat-card" key={name} style={{ '--accent': gradient }}>
      <style>{`.app-stat-card[style*="${gradient.slice(0, 30)}"]::before { background: ${gradient}; }`}</style>
      <div className="app-stat-icon-wrap" style={{ background: gradient }}>
        <i className={`fa ${icon}`} />
      </div>
      <p className="app-stat-label">{name}</p>
      {sub && <p className="app-stat-sub">{sub}</p>}
      <div className="app-stat-count">{count ?? 0}</div>
    </div>
  );

  return (
    configReport && (
      <div>
        <style>{appStatStyles}</style>
        <div className="app-stat-grid">
          {statCards.map(renderStatCard)}
        </div>
      </div>
    )
  );
};

export default ApplicationStatics;
